import { useWatch } from "react-hook-form";
import { useAgencyValue } from "#app/hooks/useAgency.js";
import { RadioButtonGroup } from "./RadioButtonGroup.jsx";

import { Text } from "@chakra-ui/react";

const validSiteTypes = {
  rv: true,
  rv_tent: true,
};

export function MaxRVLengthInput({
  name,
  maxRVLengthFilters,
  formContext,
  ...rest
}) {
  const {
    control,
    setValue,
    formState: { isDirty },
  } = formContext;

  const siteType = useWatch({ name: "siteType", control });

  const helperText = useAgencyValue({
    base: null,
    AlbertaParks: (
      <Text>
        For Alberta Parks, this size includes the towing vehicle's length
      </Text>
    ),
  });

  if (!validSiteTypes[siteType]) {
    return null;
  }

  // Hide if no RV length options available (e.g., agency doesn't track vehicle length)
  if (!maxRVLengthFilters || maxRVLengthFilters.length === 0) {
    return null;
  }

  return (
    <RadioButtonGroup
      control={control}
      name={name}
      label="What size site will fit your RV?"
      options={maxRVLengthFilters}
      helperText={helperText}
      size="sm"
      {...rest}
    />
  );
}
